/*
 * The Inspection Copy Form functions
 */
var TECL_InspectionCopyForm = {

  // Initilise the functions for the page
  Initialise: function() {

    $("#submitRequest").click(function(event) {
      TECL_InspectionCopyForm.SaveData();
    });

  },

  // Get the forms data
  SerialiseData: function() {

    var isbnVal = null;
    var productName = null;
    var productsChecked = [];

    var $isbnCntrl = $("#productIsbn");
    if ($isbnCntrl && $isbnCntrl.length > 0) {
      // Get the info about the current product
      isbnVal = $isbnCntrl.val();
      productName = $("#productName").val();

    } else {
      // Get the codes of the checked checkboxes
      $("[name=inspectionCopyProductType]").each(function() {
        var $checkboxCntrl = $(this);
        if ($checkboxCntrl && $checkboxCntrl.length > 0 && $checkboxCntrl.is(":checked")) {
          productsChecked.push($checkboxCntrl.attr("data-ProductCode"));
        }
      })
    }

    var data = {
      Title: $("#titleList").val(),
      FirstName: $("#firstName").val(),
      LastName: $("#lastName").val(),
      JobTitle: $("#jobTitle").val(),
      EmailAddress: $("#emailAdd").val(),
      TelephoneNum: $("#telNum").val(),
      OrganisationId: $("#orgId").val(),
      ProductIsbn: isbnVal,
      ProductName: productName,
      ProductsChecked: productsChecked,
      NodeId: $("#nodeId").val()
    }
    return data;
  },

  // Validate the forms data
  ValidateForm: function(data) {
    var isValid = true;

    $(".field-validation-error").addClass("hidden");

    if (!data.FirstName || data.FirstName.length < 1) {
      $("#firstNameValErr").removeClass("hidden");
      isValid = false;
    }

    if (!data.LastName || data.LastName.length < 1) {
      $("#lastNameValErr").removeClass("hidden");
      isValid = false;
    }

    if (!data.JobTitle || data.JobTitle.length < 1) {
      $("#jobTitleValErr").removeClass("hidden");
      isValid = false;
    }

    if (!data.EmailAddress || data.EmailAddress.length < 1) {
      $("#emailAddValErr").removeClass("hidden");
      isValid = false;
    } else {
      //validate the email address text
      if (!TECL_MandatoryFields.ValidateEmailAddressText(data.EmailAddress)) {
        $("#emailAddValErr").removeClass("hidden");
        isValid = false;
      }
    }

    if (!data.OrganisationId || data.OrganisationId.length < 1) {
      $("#orgSearchValErr").removeClass("hidden");
      isValid = false;
    }

    return isValid;
  },

  // Save the data 
  SaveData: function() {
    var data = TECL_InspectionCopyForm.SerialiseData();

    if (TECL_InspectionCopyForm.ValidateForm(data)) {

      $.ajax({
        url: "/umbraco/surface/InspectionCopyFormSurface/SaveInspectionCopyFormData/",
        type: "POST",
        data: {
          saveData: data
        },
        error: function() {
          // Show error modal
          TECL_InspectionCopyForm.ShowSaveErrorDlg();
        },
        success: function(saved) {
          if (saved) {
            // Display the saved panel
            $("#inpection-copy-form-controls").addClass("hidden");
            $("#inpection-copy-form-saved").removeClass("hidden");

            $("[name=inspectionCopyProductType]").each(function() {
              var $checkBox = $(this);

              if ($checkBox && $checkBox.length > 0) {
                $checkBox.attr("disabled", "disabled");
              }
            });

          } else {
            // Show error modal
            TECL_InspectionCopyForm.ShowSaveErrorDlg();
          }
        }
      });
    }
  },

  // Show the save error dialog
  ShowSaveErrorDlg: function() {
    $("#errorModal").modal("show");

    var errorText = $("#formSendError").val();
    if (!errorText) {
      errorText = "Sorry the inspection copy request failed to be sent. Please try again soon.";
    }

    $("#errorModal").find("p").text(errorText);
  }

};